import { useState, useEffect } from 'react';
import { Cloud, CloudOff, Loader2 } from 'lucide-react';
import { subscribeSyncStatus } from '../../utils/storage';

const STATUS_CONFIG = {
    synced: {
        icon: Cloud,
        label: 'Synced',
        className: 'sync-status--synced',
    },
    pending: {
        icon: Loader2,
        label: 'Syncing…',
        className: 'sync-status--pending',
    },
    error: {
        icon: CloudOff,
        label: 'Sync issue — saved locally',
        className: 'sync-status--error',
    },
};

export default function SyncStatus({ collapsed = false }) {
    const [status, setStatus] = useState('synced');

    useEffect(() => {
        const unsub = subscribeSyncStatus(setStatus);
        return unsub;
    }, []);

    const config = STATUS_CONFIG[status] || STATUS_CONFIG.synced;
    const Icon = config.icon;

    // When synced, fade out after a moment to be unobtrusive
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        if (status !== 'synced') {
            setVisible(true);
        } else {
            // Keep visible for 2s after syncing completes, then fade
            const timer = setTimeout(() => setVisible(false), 2000);
            return () => clearTimeout(timer);
        }
    }, [status]);

    return (
        <div
            className={`sync-status ${config.className} ${visible ? 'sync-status--visible' : ''}`}
            title={config.label}
        >
            <Icon size={14} className={status === 'pending' ? 'sync-status__spinner' : ''} />
            {!collapsed && <span className="sync-status__label">{config.label}</span>}
        </div>
    );
}
